import React, {Component} from "react"
import {navigate, StaticQuery} from "gatsby"
import {trackCustomEvent} from "gatsby-plugin-google-analytics"
import Img from "gatsby-image"
import feedbackStyles from "./feedback.module.css"
import Firebase from "./Firebase/firebase"

class Feedback extends Component {
    constructor(props) {
      super(props);
      this.state = {
        lesson: this.props.name,
        toggle: false,
        feedback: "",
      }
      this.modalRef = React.createRef();
      this.feedbackInputRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
      if (prevProps.name !== this.props.name) {
          this.setState({
            lesson: this.props.name,
          })
      }
    }

    handleFeedbackClick() {
      trackCustomEvent({
          category: "feedback",
          action: "open"
      });
      this.setState({toggle: true}, () => this.feedbackInputRef.current.focus());
    }

    handleModalBackgroundClick(e) {
      if (e.target === this.modalRef.current) {
        this.handleCloseClick();
      }
    }

    handleCloseClick() {
      this.setState({toggle: false, feedback:""})
    }

    sendFeedback() {
        if (this.state.feedback != "") {
            (new Firebase()).sendLessonFeedback(this.state.lesson, this.state.feedback);
            this.handleCloseClick();
        }
    }

    render() {
        return (
          <>
            <div className={feedbackStyles.feedbackButton}>
                <button onClick={() => this.handleFeedbackClick()}>
                </button>
            </div>
            <div ref={this.modalRef} className={feedbackStyles.modal} style={this.state.toggle ? {display: "block"} : {display: "none"}} onClick={(e)=>this.handleModalBackgroundClick(e)}>
              <div className={feedbackStyles.modalContent}>
                <div className={feedbackStyles.header}>
                <h3>Questions? Feedback?</h3>
                </div>
                <div style={{padding: '20px 40px 30px 40px'}}>
                  <h4 style={{fontSize: '1.1rem', lineHeight: '1.5rem'}}>Let us know if anything isn't working correctly or if there are any new topics you want us to cover!</h4>
                  <textarea ref={this.feedbackInputRef} value={this.state.feedback} onChange={(e) => this.setState({feedback: e.target.value})} style={{margin: "0px", width: "100%", height: '5rem', padding: '10px'}}/>
                  <div className={feedbackStyles.standardButton} style={{marginTop: '1rem'}}>
                    <button onClick={() => this.sendFeedback()}><h4> Send!</h4> </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
    }
}

export default Feedback;
